export default "__VITE_ASSET__BT94k5XJ__"